module.exports = __webpack_public_path__ + "img/Pinata.358f0e3.jpg";